import config from "../../config";

export default {
  AUTH: {
    LOGIN: `${config.baseApiUrl}auth/login`,
    LOGOUT: `${config.baseApiUrl}auth/logout`,
    REFRESH_TOKEN: `${config.baseApiUrl}auth/refreshToken`,
    REGISTRATION: `${config.baseApiUrl}auth/registration`,
    FORGOT_PASSWORD: `${config.baseApiUrl}auth/password/recovery`,
    RESET_PASSWORD: `${config.baseApiUrl}auth/password`,
  },
  USER: {
    GET_USER_INFO: `${config.baseApiUrl}users/details`,
    GET_USERS_LIST: `${config.baseApiUrl}users`,
    GET_USERS_LIST_SUMMARY: `${config.baseApiUrl}users/summary`,
    CHECK_USER_PAYMENT_METHOD: (id: number) => `${config.baseApiUrl}users/${id}/payment-method`,
    GET_CHECKOUT_URL: (id: number) => `${config.baseApiUrl}users/${id}/checkout-url`,
    GET_BILLING_PORTAL_URL: (id: number) => `${config.baseApiUrl}users/${id}/billing-portal-url`,
  },
  CASE: {
    GET_CASES_LIST: `${config.baseApiUrl}cases`,
    GET_CASES_STATUSES: `${config.baseApiUrl}cases/statuses`,
    GET_CASE: (id: number) => `${config.baseApiUrl}cases/${id}`,
    CREATE_CASE: `${config.baseApiUrl}cases`,
    DELETE_CASE: (id: number) => `${config.baseApiUrl}cases/${id}`,
    RESTART_PROCESSING_CASE: (id: number) => `${config.baseApiUrl}cases/${id}/restart-processing`,
    UPDATE_CASE_REPORT_STATUS: (id: number) => `${config.baseApiUrl}cases/${id}/report-status`,
    GET_CASE_FILE_SIGNED_URL: (id: number) => `${config.baseApiUrl}cases/${id}/input-file`,
    GET_CASE_FILE_VIEW_URL: (id: number, fileId: number) => `${config.baseApiUrl}cases/${id}/files/${fileId}/view-url`,
    CREATE_CASE_FILE: (id: number) => `${config.baseApiUrl}cases/${id}/files`,
    CONFIRM_CASE_FILE: (id: number, fileId: number) => `${config.baseApiUrl}cases/${id}/files/${fileId}/confirm`,
    DELETE_CASE_FILE: (id: number, fileId: number) => `${config.baseApiUrl}cases/${id}/files/${fileId}`,
    DISCARD_TEMPORARY_CASE_FILES: (id: number, kind: string) =>
      `${config.baseApiUrl}cases/${id}/documents/${kind}/temporary-files`,
    PARSE_CASE_DOCUMENT: (id: number, kind: string) => `${config.baseApiUrl}cases/${id}/documents/${kind}/parse`,
    RETRY_CASE_DOCUMENT: (id: number, kind: string) => `${config.baseApiUrl}cases/${id}/documents/${kind}/retry`,
    REMOVE_CASE_DOCUMENT: (id: number, kind: string) => `${config.baseApiUrl}cases/${id}/documents/${kind}/remove`,
    GET_MEDICAL_RECORDS_RESULT: (id: number) => `${config.baseApiUrl}cases/${id}/documents/medical/result`,
    CHOOSE_MEDICAL_FIELD_VALUE: (id: number) => `${config.baseApiUrl}cases/${id}/documents/medical/choices`,
    VERIFY_MEDICAL_FIELD: (id: number) => `${config.baseApiUrl}cases/${id}/documents/medical/verify`,
    PAY_FOR_CASE: (id: number) => `${config.baseApiUrl}cases/${id}/payment`,
    UPDATE_CASE: (id: number) => `${config.baseApiUrl}cases/${id}`,
  },
  EVAL: {
    GET_RUNS: `${config.baseApiUrl}evals/runs`,
    GET_RUN: (uuid: string) => `${config.baseApiUrl}evals/runs/${uuid}`,
    DELETE_RUN: (uuid: string) => `${config.baseApiUrl}evals/runs/${uuid}`,
    RUN_CSV: `${config.baseApiUrl}evals/run-csv`,
    GET_TEMPLATE: `${config.baseApiUrl}evals/template`,
    GET_CATEGORIES: `${config.baseApiUrl}evals/categories`,
  },
};
